import { projectsDataStore } from "Stores";

export function locateFileInDocuments(folderId: number, fileId: number) {
  window.open(
    `${window.location.origin}/${window.GLOBAL.API_BASE}/project/${projectsDataStore.projectId}/documents/docs/${folderId}?file=${fileId}`
  );
}
